<template>
    <div class="accordion">
        <slot name="accordion-captions"></slot>
        <slot></slot>
    </div>
</template>

<script>
export default {}
</script>
